import React from 'react'
import styles from './WorkflowNav.module.scss'

function SubtabNav({ tabs, activeTab, onTabChange }) {
  return (
    <div className={styles.subtabNav} role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={[
            styles.subtabButton,
            tab.id === 'assist' ? styles.subtabAssist : '',
            activeTab === tab.id ? styles.subtabActive : '',
            activeTab === tab.id && tab.id === 'assist' ? styles.subtabAssistActive : '',
          ].join(' ')}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default React.memo(SubtabNav)
